import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';
import {
  createTrainingCenterSuccessAction,
  getTrainingCentersSuccessAction,
  setTrainingCenterLoading,
  updateTrainingCenterSuccessAction,
  setTrainingCenterCount,
  getTrainingCentersAction,
  getSingleTrainingCenterSuccess,
  deleteTrainingCenterSuccessAction,
  switchTrainingCenterSuccessAction,
  addtrainingCenterCourseSuccessAction,
  editTrainingCenterCourseSuccessAction,
  deleteTrainingCenterCourseSuccessAction,
} from './Actions';
import {
  newSuccessNotificationAction,
  errorNotificationFromError,
} from '../notifications/Actions';
import * as api from './Api';
import { setRedirectFalse, setRedirectTrue } from '../globalFail/Action';
import { push, goBack } from 'connected-react-router';

function* getTrainingCenters({ payload }) {
  const defBody = {
    offset: 0,
    size: 10,
    searchTerm: '',
    sort: 'name',
    dir: 'asc',
    filterBy: [],
  };
  const body = { ...defBody, ...payload };
  try {
    yield put(setTrainingCenterLoading(true));
    const response = yield call(api.getTrainingCenters, body);
    const { data } = response;
    const { content, count } = data;
    console.log('data', data);
    yield put(getTrainingCentersSuccessAction(content));
    yield put(setTrainingCenterCount(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setTrainingCenterLoading(false));
  }
}

function* getSingleTrainingCenter({ payload }) {
  try {
    yield put(setTrainingCenterLoading(true));
    const response = yield call(api.getSingleTrainingCenter, payload);
    const { data } = response;
    console.log(data);
    yield put(getSingleTrainingCenterSuccess(data));
    // yield put(newSuccessNotificationAction('Training Center Updated'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setTrainingCenterLoading(false));
  }
}

function* deleteTrainingCenter({ payload }) {
  try {
    yield put(setTrainingCenterLoading(true));
    yield call(api.deleteTrainingCenter, payload);
    yield put(deleteTrainingCenterSuccessAction(payload));
    yield put(newSuccessNotificationAction('Training Center Deleted'));
  } catch (error) {
  } finally {
    yield put(setTrainingCenterLoading(false));
  }
}

function* createTrainingCenter({ payload, noRedirect }) {
  yield put(setRedirectFalse());
  try {
    yield put(setTrainingCenterLoading(true));
    const response = yield call(api.createTrainingCenter, payload);
    const { data } = response;

    yield put(createTrainingCenterSuccessAction(data));
    yield put(newSuccessNotificationAction('Training Center Created'));
    if (!noRedirect) {
      yield put(push('/training-center'));
    }
    yield put(setRedirectTrue());
  } catch (err) {
    yield put(errorNotificationFromError(err));
  } finally {
    yield put(setTrainingCenterLoading(false));
  }
}

function* updateTrainingCenter({ payload, noRedirect }) {
  const { id, formData } = payload;
  try {
    yield put(setTrainingCenterLoading(true));
    const response = yield call(api.updateTrainingCenter, id, formData);
    const { data } = response;

    yield put(updateTrainingCenterSuccessAction(data));
    yield put(newSuccessNotificationAction('Training Center Updated'));
    if (!noRedirect) {
      yield put(push('/training-center'));
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setTrainingCenterLoading(false));
  }
}

function* switchTrainingCenter({ payload }) {
  const { id, formData } = payload;
  try {
    yield put(setTrainingCenterLoading(true));
    const response = yield call(api.switchTrainingCenter, id, formData);
    const { data } = response;

    yield put(switchTrainingCenterSuccessAction(data));
    yield put(newSuccessNotificationAction('Training Center Updated'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setTrainingCenterLoading(false));
  }
}

function* addTrainingCenterCourse({ payload }) {
  try {
    yield put(setTrainingCenterLoading(true));
    const response = yield call(api.addTrainingCenterCourse, payload);
    const { data } = response;

    yield put(addtrainingCenterCourseSuccessAction(data));
    yield put(newSuccessNotificationAction('Training Center Course Added'));
    yield put(goBack());
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setTrainingCenterLoading(false));
  }
}

function* editTrainingCenterCourse({ payload }) {
  try {
    yield put(setTrainingCenterLoading(true));
    const response = yield call(api.editTrainingCenterCourse, payload);
    const { data } = response;

    yield put(editTrainingCenterCourseSuccessAction(data));
    yield put(newSuccessNotificationAction('Training Center Course Updated'));
    yield put(goBack());
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setTrainingCenterLoading(false));
  }
}

function* deleteTrainingCenterCourse({ payload }) {
  try {
    yield put(setTrainingCenterLoading(true));
    const response = yield call(api.deleteTrainingCenterCourse, payload);
    const { data } = response;

    yield put(deleteTrainingCenterCourseSuccessAction(payload));
    yield put(newSuccessNotificationAction('Training Center Course Deleted'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setTrainingCenterLoading(false));
  }
}

export default function*() {
  yield takeLatest(actions.CREATE_TRAINING_CENTER, createTrainingCenter);
  yield takeLatest(actions.UPDATE_TRAINING_CENTER, updateTrainingCenter);
  yield takeLatest(actions.GET_TRAINING_CENTERS, getTrainingCenters);
  yield takeLatest(actions.GET_SINGLE_TRAINING_CENTER, getSingleTrainingCenter);
  yield takeLatest(actions.DELETE_TRAINING_CENTER, deleteTrainingCenter);
  yield takeLatest(actions.SWITCH_TRAINING_CENTER, switchTrainingCenter);
  yield takeLatest(actions.ADD_TRAINING_CENTER_COURSE, addTrainingCenterCourse);
  yield takeLatest(
    actions.EDIT_TRAINING_CENTER_COURSE,
    editTrainingCenterCourse
  );
  yield takeLatest(
    actions.DELETE_TRAINING_CENTER_COURSE,
    deleteTrainingCenterCourse
  );
}
